import { t } from "i18next";
import { useEffect, useState } from "react";

import Star from "@/assets/icons/big-star.svg?react";
import Mark from "@/assets/icons/mark.svg?react";
import Telegram from "@/assets/icons/telegram.svg?react";
import X from "@/assets/icons/x.svg?react";
import { ToastService } from "@/components/ToastService";
import { useStore } from "@/hooks/store";
import { useLevelActions } from "@/hooks/useLevelActions";
import { LevelProps } from "@/interfaces/components";
import { colors } from "@/theme/colors";
import { delay } from "@/utils";

import styles from "./styles";
import { LevelButton } from "../LevelButton";
import { LevelButtonContainer } from "../LevelButton/styles";

export const Level3 = ({ title, description, style, level, img }: LevelProps) => {
  const { x, telegram } = useStore((store) => store.user);
  const { connectTelegram, connectX } = useLevelActions();
  const [href, setHref] = useState<string | undefined>();

  const [telegramLoading, setTelegramLoading] = useState(false);
  const [xLoading, setXLoading] = useState(false);

  const handlerTelegram = async () => {
    setTelegramLoading(true);
    await delay(2000);
    const success = await connectTelegram();
    if (success) {
      ToastService.simple({
        text: t("Messages.TelegramConnectedSuccessfully"),
        icon: <Mark />,
        style: { background: colors.green, color: colors.white, border: "none" },
      });
    }
    setTelegramLoading(false);
  };

  const handlerX = () => {
    if (href) {
      setXLoading(true);
      window.open(href);
      setTimeout(() => {
        setXLoading(false);
      }, 10000);
    }
  };

  useEffect(() => {
    if (!telegram) return;
    const loadLink = async () => {
      const url = await connectX();
      if (url) {
        setHref(url);
      }
    };
    loadLink();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [telegram]);

  return (
    <styles.Level>
      <styles.Header>
        <styles.StarContainer $starColor={style.border}>
          <Star />
        </styles.StarContainer>
        <img src={img} />
        <styles.LevelOctagon $colors={style}>{t("Levels.Level", { level: level })}</styles.LevelOctagon>
      </styles.Header>
      <styles.Footer>
        <styles.LevelTextCol>
          <styles.LevelTitle>{title}</styles.LevelTitle>
          {description && <styles.LevelDescription>{description}</styles.LevelDescription>}
        </styles.LevelTextCol>
        <LevelButtonContainer>
          <LevelButton
            key="ConnectTelegram"
            name={telegramLoading ? "ConnectingTelegram" : "ConnectTelegram"}
            handler={handlerTelegram}
            icon={<Telegram />}
            status={telegram ? "completed" : "empty"}
            disabled={telegram || telegramLoading}
            iconBg={colors.telegram}
            loading={telegramLoading}
          />
          <LevelButton
            key="ConnectX"
            name={xLoading ? "ConnectingX" : "ConnectX"}
            handler={handlerX}
            icon={<X />}
            status={x ? "completed" : "empty"}
            disabled={!href || x || !telegram || xLoading}
            iconBg={colors.black}
            loading={xLoading}
          />
        </LevelButtonContainer>
      </styles.Footer>
    </styles.Level>
  );
};
